import { sentry } from '../../../lib/sentry';
import { setCourseData } from './setCourseData';
import { startCourseFetch } from './startCourseFetch';
const getCourseFromResponse = async response => {
  if (!response.ok) {
    sentry.captureError(new Error("Failed to fetch Course: ".concat(response.statusText)));
  }
  switch (response.status) {
    case 204:
      return null;
    case 200:
      {
        const content = await response.json();
        return {
          id: content.id,
          mobile_enabled: content.mobile_enabled
        };
      }
    default:
      sentry.captureError(new Error("Failed to fetch Course: ".concat(response.statusText)));
      return null;
  }
};
export const getCourse = _ref => {
  let {
    campusApiUrl,
    courseId
  } = _ref;
  return async dispatch => {
    dispatch(startCourseFetch());
    const response = await fetch("".concat(campusApiUrl, "/api/courses/").concat(courseId), {
      credentials: 'include'
    });
    const data = await getCourseFromResponse(response);
    dispatch(setCourseData(data));
  };
};